import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { SanctuaryShell, sanctuaryLinks } from './SanctuaryShell';

function SanctuaryRefund() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <main className="main sanctuary-page-root">
      <SanctuaryShell>
        <article className="sanc-wrap sanc-legal">
          <Link className="sanc-back" to="/projects/sanctuary">
            ← Sanctuary home
          </Link>
          <h1 className="sanc-legal__title">Refund &amp; Cancellation</h1>
          <p className="sanc-legal__meta">
            Sanctuary · Last updated: 14 July 2026 · {sanctuaryLinks.business}
          </p>

          <h2>1. Two different money flows</h2>
          <p>
            Please read carefully — Sanctuary handles <strong>two separate</strong> types of
            payments:
          </p>
          <ul>
            <li>
              <strong>Student / library fees</strong> — membership or seat fees paid by
              students (online when enabled by the library). These go to the{' '}
              <strong>library’s Razorpay / bank</strong>. Sanctuary does not hold student money.
            </li>
            <li>
              <strong>Sanctuary product subscription / platform charges</strong> — amounts a
              Manager may pay to {sanctuaryLinks.business} for using Sanctuary (e.g. Pro plan or
              disclosed platform fees).
            </li>
          </ul>

          <h2>2. Student fees (library)</h2>
          <p>
            Refunds, cancellations, or disputes for student membership fees are between the
            student and the <strong>library Manager</strong>. Contact your library first. Online
            instruments may also follow Razorpay’s and the library’s settlement practices.
            Sanctuary is not the merchant of record for those student fee collections.
          </p>

          <h2>3. Sanctuary subscription / platform fees</h2>
          <ul>
            <li>
              Manager subscriptions (if active) renew as shown in-app or at checkout unless
              cancelled before the next billing date where self-serve cancellation is available.
            </li>
            <li>
              For accidental duplicate charges or clear billing errors on Sanctuary’s own fees,
              email <a href={`mailto:${sanctuaryLinks.email}`}>{sanctuaryLinks.email}</a> within
              7 days with transaction details. Eligible cases may be refunded after verification.
            </li>
            <li>
              Generally, completed subscription periods already used are non-refundable except
              where required by law or as we approve case-by-case.
            </li>
          </ul>

          <h2>4. How to request help</h2>
          <p>
            Email: <a href={`mailto:${sanctuaryLinks.email}`}>{sanctuaryLinks.email}</a>
            <br />
            Phone: <a href={sanctuaryLinks.phoneTel}>+91 {sanctuaryLinks.phone}</a>
            <br />
            Include: role (Manager/Student), library name, transaction/order ID, and a short
            description.
          </p>

          <h2>5. Contact</h2>
          <p>
            {sanctuaryLinks.business}
            <br />
            {sanctuaryLinks.address}
            <br />
            Udyam: {sanctuaryLinks.udyam}
          </p>
        </article>
      </SanctuaryShell>
    </main>
  );
}

export default SanctuaryRefund;
